import type { ReactNode } from 'react';

interface ReportSectionProps {
    title: string;
    children: ReactNode;
    loading?: boolean;
    error?: string | null;
    meta?: Record<string, unknown>;
}

export function ReportSection({ title, children, loading, error, meta }: ReportSectionProps) {
    return (
        <div className="space-y-4">
            <h3 className="text-base font-semibold text-gray-800">{title}</h3>
            {error && (
                <div className="px-4 py-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                    Erreur : {error}
                </div>
            )}
            {!!meta?.message && (
                <div className="px-4 py-3 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-700 text-sm">
                    {meta.message as string}
                </div>
            )}
            {loading && !error && (
                <div className="flex justify-center py-8">
                    <div className="w-8 h-8 border-4 border-gray-200 border-t-brand-500 rounded-full animate-spin" />
                </div>
            )}
            {!loading && !error && children}
        </div>
    );
}
